import { render, staticRenderFns } from "./DialogCodeImport.vue?vue&type=template&id=6ffb220f&scoped=true&"
import script from "./DialogCodeImport.vue?vue&type=script&lang=js&"
export * from "./DialogCodeImport.vue?vue&type=script&lang=js&"
import style0 from "./DialogCodeImport.vue?vue&type=style&index=0&id=6ffb220f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb220f",
  null
  
)

export default component.exports